




























































































import { mapActions } from 'vuex';

import QuoteStateMixin from '@/mixins/quoteState';

import { QuoteState } from '@/models/quote';
import { ErrorManager } from '@/models/error';

import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';

import ErrorAlert from '@/components/common/ErrorAlert.vue';
import QuoteLayoutMixin from '@/mixins/quotes/QuoteLayoutMixin';

export default mixins(QuoteStateMixin, auth, QuoteLayoutMixin).extend({
  components: { ErrorAlert },

  name: 'QuoteInReviewStateCard',

  computed: {
    getColor(): string {
      return 'submitted';
    },

    getIcon(): string {
      return 'mdi-file-search-outline';
    },

    getString(): string {
      return 'Review In Progress';
    },

    getActionText(): string {
      return this.useMachineLayout(this.quote)
        ? 'Review Discounts'
        : this.quote.isTariffsApplicable()
        ? 'Review Surcharges'
        : 'Approve';
    }
  },

  data: () => ({
    loading: false
  }),

  methods: {
    ...mapActions({
      setQuoteState: 'quote/setQuoteState'
    }),

    approve() {
      return this.setState(QuoteState.APPROVED);
    },

    reviewDiscounts() {
      return this.setState(QuoteState.REVIEWING_DISCOUNTS);
    },

    reviewSurcharges() {
      return this.setState(QuoteState.REVIEWING_SURCHARGES);
    },

    setState(state: QuoteState) {
      this.clearAllErrors();

      this.loading = true;

      this.setQuoteState({ id: this.quote.number, state })
        .then(({ state }) => {
          this.$emit('state-changed:quote', {
            number: this.quote.number,
            revision: this.quote.revision,
            state: state
          });
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    forwardNextApplicableState() {
      return this.useMachineLayout(this.quote)
        ? this.reviewDiscounts()
        : this.quote.isTariffsApplicable()
        ? this.reviewSurcharges()
        : this.approve();
    }
  }
});
